module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-BoldIt.f10814ec.otf";